
































































































































































import { Component, Vue, Watch, Prop, Emit } from 'vue-property-decorator';
import { Inject } from '@cds/common';
import { NuoxiaoerService } from '@/services/nuoxiaoer-service';
import { massSet } from '@/services/massage-service';
import { ElForm } from 'element-ui/types/form';

@Component({
  components: {}
})
export default class NotifyPopup extends Vue {
  @Inject(NuoxiaoerService) private nuoxiaoerService!: NuoxiaoerService;
  @Inject(massSet) private massSet!: massSet;

  @Emit('saved')
  private async emitSaved(): Promise<void> {
  }

  @Emit('cancel')
  private async emitClose(): Promise<void> {
  }

  @Prop() private notifyId!: Number;

  @Watch('notifyId', { immediate: true, deep: true })
  public onChangeNotifyId(newVal: any, oldVal: any) {
    console.log('notifyId watch', newVal)
    const isEdit = typeof newVal === 'number';
    this.isEdit = isEdit;
    if (isEdit) {
      this.fetchNotifyDetail();
    } else {
      this.resetFormData();
      this.fetchUserGroups();
    }
  }

  // 添加组件激活时的生命周期钩子
  public activated(): void {
    // 每次组件激活时，如果不是编辑模式，都重置表单数据
    if (!this.isEdit) {
      this.resetFormData();
      this.fetchUserGroups();
    }
  }

  public isEdit: Boolean = false;

  // 表单数据
  public formData: any = {
    id: null,
    type: 2, // 1-文档，3-智能问答
    message: '',
    content: '',
    openRange: [], // 对应 ArticleModulePopup 中的 openRange
    userGroups: [], // 对应 ArticleModulePopup 中的 userGroups
    emails: [],
    emailsStr: ''
  };

  // 消息类型选项
  public messageTypeOptions: any[] = [
    { value: 2, label: '文档' },
    { value: 3, label: '智能问答' }
  ];

  // 用户组选项
  public buOptions: any[] = [];

  // 用户组选项
  public userGroupOptions: any[] = [];

  // 表单校验规则
  public rules: any = {
    type: [{ required: true, message: '请选择消息类型', trigger: 'change' }],
    message: [{ required: true, message: '请输入消息标题', trigger: 'blur' }],
    content: [{ required: true, message: '请输入消息内容', trigger: 'blur' }]
  };

  // 用户检测相关
  public totalNum: number = 0; // 总个数
  public noNum: number = 0; // 无效个数
  public useNum: number = 0; // 有效个数
  public noNumshow: Boolean = false;
  public subShow: Boolean = true;

  public async created(): Promise<void> {
  }

  // 获取用户范围
  private async fetchUserGroups(): Promise<void> {
    try {
      // 获取BU列表
      const buRes = await this.nuoxiaoerService.getBUList();
      // 获取用户组列表
      const userGroupRes = await this.nuoxiaoerService.fetchUserGroupList({});

      if (buRes && Array.isArray(buRes)) {
        // 直接使用API返回的数据格式，参考ArticleModulePopup的方式
        this.buOptions = buRes;
      } else {
        // 如果接口返回格式与预期不符，提供一个默认的数据结构
        this.buOptions = [];
      }

      // 处理用户组数据，参考ArticleModulePopup的方式
      if (userGroupRes && Array.isArray(userGroupRes)) {
        this.userGroupOptions = userGroupRes.map((group: any) => ({
          id: group.groupId,
          name: group.groupName,
          type: group.groupType
        }));
      } else {
        this.userGroupOptions = [];
      }
    } catch (error) {
      console.error('获取用户范围和用户组失败：', error);
      this.$message.error('获取用户范围和用户组失败，请刷新重试');

      // 失败时使用默认值
      this.buOptions = [];
      this.userGroupOptions = [];
    }
  }

  // 获取通知详情
  private async fetchNotifyDetail(): Promise<void> {
    try {
      const res = await this.nuoxiaoerService.fetchNotifyDetail({ id: this.notifyId });

      if (res) {
        this.formData = {
          id: res.id,
          type: res.type || 2,
          message: res.message || '',
          content: res.content || '',
          // 处理用户范围 - 详情返回的openRange为数组类型
          openRange: res.openScope || [],
          // 处理用户组 - 参考ArticleModulePopup的方式，从用户组数组中提取groupId
          userGroups: res.userGroups ? res.userGroups.map((group: any) => group.groupId || group.id) : [],
          emails: res.emails || [],
          emailsStr: (res.emails || []).join(','),
          sortNumber: res.sortNumber
        };

        // 处理邮箱字符串
        this.handleEmailsInput();
      }

      // 获取用户分组选项
      await this.fetchUserGroups();
    } catch (error) {
      console.error('获取通知详情失败：', error);
      this.$message.error('获取通知详情失败，请刷新重试');
    }
  }

  // 重置表单数据
  private resetFormData(): void {
    this.formData = {
      id: null,
      type: 2,
      message: '',
      content: '',
      openRange: [],
      userGroups: [],
      emails: [],
      emailsStr: '',
      sortNumber: null
    };

    // 重置用户检测状态
    this.totalNum = 0;
    this.noNum = 0;
    this.useNum = 0;
    this.noNumshow = false;
    this.subShow = true;

    // 清除表单验证状态
    this.$nextTick(() => {
      if (this.$refs.notifyForm) {
        (this.$refs.notifyForm as ElForm).clearValidate();
      }
    });
  }

  // 处理邮箱输入
  public handleEmailsInput(): void {
    this.noNumshow = false;
    
    if (!this.formData.emailsStr || this.formData.emailsStr.trim() === '') {
      this.totalNum = 0;
    } else {
      // 不在输入时立即格式化，只统计邮箱数量
      // 统计时支持中文逗号和英文逗号分隔
      const strLength = this.formData.emailsStr.split(/[,，]/);
      const validEmails = strLength.map(email => email.trim()).filter(email => email);
      this.totalNum = validEmails.length;
    }
    
    if (this.totalNum > 0) {
      this.subShow = false;
    } else {
      this.subShow = true;
    }
  }

  // 处理邮箱输入时的按键事件
  public handleEmailKeydown(event: KeyboardEvent): void {
    // 阻止回车键换行
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }

  // 格式化邮箱字符串（在检测用户或提交时调用）
  private formatEmailString(): string {
    if (!this.formData.emailsStr || this.formData.emailsStr.trim() === '') {
      return '';
    }
    
    // 支持中文逗号和英文逗号分隔，在处理时统一转换为英文逗号
    const strLength = this.formData.emailsStr.split(/[,，]/);
    const validEmails = Array.from(new Set(strLength.map(email => email.trim()).filter(email => email)));
    return validEmails.join(',');
  }

  // 检测用户
  public async checkPerson(): Promise<void> {
    if (!this.formData.emailsStr || this.formData.emailsStr.trim() === '') {
      this.$message.error('请先输入用户邮箱');
      return;
    }

    try {
      const data = {
        usersStr: this.formData.emailsStr
      };
      
      const res: any = await this.massSet.persnSearch(data);
      
      if (res) {
        this.noNum = res.unFinds.length;
        this.useNum = res.empIds.length + res.emails.length;
        this.totalNum = res.unFinds.length + res.empIds.length + res.emails.length;
        this.noNumshow = true;
        this.formData.emailsStr = res.usersStr;
        
        if (res.unFinds.length > 0) {
          this.subShow = false;
          this.$alert('用户：' + res.unFinds.toString() + ' 不存在', '错误用户', {
            confirmButtonText: '确定',
            callback: () => {}
          });
        } else {
          this.$message({
            type: 'success',
            message: '用户检测完成'
          });
          this.subShow = true;
        }
      }
    } catch (error) {
      console.error('检测用户失败：', error);
      this.$message.error('检测用户失败，请重试');
    }
  }

  // 提交表单
  public submitForm(): void {
    (this.$refs.notifyForm as ElForm).validate(async (isValid: boolean) => {
      if (!isValid) {
        this.$message.error('请检查并完善表单信息');
        return;
      }

      // 验证用户范围、用户组和用户邮箱至少填写一项
      const hasOpenRange = this.formData.openRange && this.formData.openRange.length > 0;
      const hasUserGroups = this.formData.userGroups && this.formData.userGroups.length > 0;
      const hasEmails = this.formData.emailsStr && this.formData.emailsStr.trim() !== '';
      
      if (!hasOpenRange && !hasUserGroups && !hasEmails) {
        this.$message.error('用户范围、用户组和用户邮箱必须至少填写一项');
        return;
      }

      // 如果有邮箱但未检测，需要先检测
      if (this.formData.emailsStr && this.formData.emailsStr.trim() !== '' && !this.subShow && !this.noNumshow) {
        this.$message.error('请先检测用户邮箱');
        return;
      }

      try {
        // 确认发布
        await this.$confirm('是否确认信息发布？', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'info'
        });
        // 构建提交数据
        const submitData: any = {
          type: this.formData.type,
          message: this.formData.message,
          content: this.formData.content,
          sortNumber: this.formData.sortNumber || 0,
          // 处理用户范围 - 将数组转换为逗号分隔的字符串，参考ArticleModulePopup
          openScope: this.formData.openRange,
          // 处理用户组 - 参考ArticleModulePopup的方式，构建用户组对象数组
          userGroups: this.formData.userGroups.map((groupId: string) => {
            // 查找对应的用户组信息
            const group = this.userGroupOptions.find((item: any) => item.id === groupId);
            return {
              groupId: groupId,
              groupName: group ? group.name : '',
              groupType: group ? group.type : ''
            };
          }),
          emails: this.formData.emailsStr ? this.formData.emailsStr.split(',').map(email => email.trim()).filter(email => email) : []
        };

        if (this.isEdit) {
          submitData.id = this.formData.id;
          const res = await this.nuoxiaoerService.updateNotify(submitData, {headers: {needResponse: true}});
          console.log(res)
          const code = res && res.header && res.header.code;
          if (code && code !== 200) {
            throw new Error(res.header.message || '删除失败');
          }
        } else {
          const res =await this.nuoxiaoerService.addNotify(submitData, {headers: {needResponse: true}});
          const code = res && res.header && res.header.code;
          console.log(res)
          if (code && code !== 200) {
            throw new Error(res.header.message || '删除失败');
          }
        }

        this.$message({
          message: '保存成功',
          type: 'success'
        });

        this.emitSaved();
      } catch (error) {
        if (error === 'cancel') {
          return;
        }
        console.error('保存失败：', error);
        this.$message.error('保存失败：' + (error.message || '未知错误'));
      }
    });
  }

  // 取消按钮
  public async handleCancel(): Promise<void> {
    try {
      await this.$confirm('是否确认离开当前界面？离开后，当前界面内容将会丢失', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      });
      this.emitClose();
    } catch (error) {
      // 用户取消操作，不做处理
    }
  }
}
